import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object({
    conditions: Yup.string().required("Please Provide Description")
  }),

  validateOnMount: true,
  mapPropsToValues: props => ({
    conditions: ""
  }),

  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
